import { animate } from 'animejs';

class Module06Temoignage {
  constructor() {
    let scrollPos = 0;
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
        cache.sectionCard = document.querySelector('.module-06-temoignage .layout-anime');
        cache.cards = cache.sectionCard.querySelectorAll('.temoignage_card');
    };

    let registerEvents = () => {
        window.addEventListener('scroll', scrollCards);
    };



    let scrollCards = function(event) {
        let up = false;
        if(scrollPos > window.pageYOffset) {
          up = true;
        }
        scrollPos = window.pageYOffset;
    
    
        if(((scrollPos + window.innerHeight) > (cache.sectionCard.offsetTop + window.innerHeight)) && ((scrollPos + window.innerHeight) < (cache.sectionCard.offsetTop + window.innerHeight + cache.sectionCard.offsetHeight/3))) {
          let percent = (scrollPos - cache.sectionCard.offsetTop)/(cache.sectionCard.offsetHeight/3);
          if(percent > 0.5) {
            cache.cards[0].style.zIndex = 1;
            cache.cards[1].style.zIndex = 3;
            cache.cards[2].style.zIndex = 2;
          } else {
            cache.cards[0].style.zIndex = 3;
            cache.cards[1].style.zIndex = 2;
            cache.cards[2].style.zIndex = 1;
          }
          
          let card1 = animate(cache.cards[0], {
            duration: 400,
            translateY: ['0%','-105%'],
            ease: 'inOutQuad',
            autoplay: false,
            onComplete: function() {
                let card1_2 = animate(cache.cards[0], {
                    duration: 400,
                    translateY: ['-105%', '12%'],
                    ease: 'easeOutQuad',
                    autoplay: false,
                });
                card1_2.seek(((percent*2) - 1) * card1_2.duration);
            }
          });
    
          let card2 = animate(cache.cards[1], {
            duration: 400,
            delay: 100,
            translateY: ['6%', '0%'],
            ease: 'easeInOutQuad',
            autoplay: false
          });
    
          let card3 = animate(cache.cards[2], {
            duration: 400,
            delay: 200,
            translateY: ['12%', '6%'],
            ease: 'easeInOutQuad',
            autoplay: false
          });
    
          card1.seek((percent*2) * card1.duration);
          card2.seek((percent) * card2.duration);
          card3.seek((percent) * card3.duration);
        }
    
        if(((scrollPos + window.innerHeight) > (cache.sectionCard.offsetTop + window.innerHeight + cache.sectionCard.offsetHeight/3)) && ((scrollPos + window.innerHeight) < (cache.sectionCard.offsetTop + window.innerHeight + cache.sectionCard.offsetHeight))) {
          let percent = (scrollPos - cache.sectionCard.offsetTop - cache.sectionCard.offsetHeight/3)/(cache.sectionCard.offsetHeight/3);
          if(percent < 0.5) {
            cache.cards[1].style.zIndex = 3;
            cache.cards[2].style.zIndex = 2;
            cache.cards[0].style.zIndex = 1;
          } else {
            cache.cards[1].style.zIndex = 1;
            cache.cards[2].style.zIndex = 3;
            cache.cards[0].style.zIndex = 2;
          }
            
          let card1 = animate(cache.cards[1], {
            duration: 400,
            translateY: ['0%','-105%'],
            ease: 'inOutQuad',
            autoplay: false,
            onComplete: function() {
                let card1_2 = animate(cache.cards[1], {
                    duration: 400,
                    translateY: ['-105%', '12%'],
                    ease: 'easeOutQuad',
                    autoplay: false,
                });
                card1_2.seek(((percent*2) - 1) * card1_2.duration);
            }
          });
    
          let card2 = animate(cache.cards[2], {
            duration: 400,
            delay: 100,
            translateY: ['6%', '0%'],
            ease: 'easeInOutQuad',
            autoplay: false
          });
    
          let card3 = animate(cache.cards[0], {
            duration: 400,
            delay: 200,
            translateY: ['12%', '6%'],
            ease: 'easeInOutQuad',
            autoplay: false
          });
    
          card1.seek((percent*2) * card1.duration);
          card2.seek((percent) * card2.duration);
          card3.seek((percent) * card3.duration);
        }
    
    }

    initFunc();
  };
}
export { Module06Temoignage }